import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { getAccountInfo } from '../reducers/getAccount';

interface actionStateProps {
  loading: boolean;
  error: unknown;
  getAccount: (id: string) => void;
}

const useGetAccount = (): actionStateProps => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  const getAccount = async (id: string) => {
    try {
      setLoading(true);
      const resultAction = await dispatch(getAccountInfo(id));
      if (getAccountInfo.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }
  };

  return { loading, error, getAccount };
};

export default useGetAccount;
